export const options = {
    all: {
        label: 'All',
        icon: '✳︎',
        value: 'all',
        color: '#999',
    },
    ff: {
        label: 'Feature Flags',
        icon: '❖',
        value: 'ff',
        color: '#7cacf8',
    },
    ab: {
        label: 'A/B Experiments',
        icon: '✦',
        value: 'ab',
        color: '#c49df0',
    },
    control: {
        label: 'Controls',
        icon: '⛏︎',
        value: 'control',
        color: '#e87a7a',
    },
};
